import { AiOutlineClose } from "react-icons/ai";

function ModalHeader({ modalHeading, handleClose }) {
  return (
    <div className="modal-header">
      <button className="close-button" onClick={handleClose}>
        <AiOutlineClose />
      </button>
    </div>
  );
}

export default ModalHeader;
